var map = {
	"./activerecord.en.yml": 1520,
	"./d2p.en.yml": 1521,
	"./devise.en.yml": 1522,
	"./en-GB.yml": 1523,
	"./en.yml": 1524,
	"./kaminari.en.yml": 1525,
	"./simple_form.en.yml": 1526,
	"./system_campaigns.en-GB.yml": 1527,
	"./system_campaigns.en.yml": 1528,
	"./system_campaigns.fr.yml": 1529,
	"./wwd_community.en.yml": 1530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1519;